import React from "react";
import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithHistory = ({ children }) => {

  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    // Extract error details from URL to check if there was an error
    const error = new URLSearchParams(window.location.search).get('error');
    
    if (error) {
      // Log error for debugging and stop any further action
      console.log(`Error detected: ${new URLSearchParams(window.location.search).get('error_description')}`);
      // Stop any further navigation or processing
      return;
    }
  
    // Navigate to the intended page after login if no error
    navigate(appState?.returnTo || "/");
  };


  let REACT_APP_AUTH0_DOMAIN;
  let REACT_APP_AUTH0_CLIENT_ID;
  let REACT_APP_AUTH0_AUDIENCE;
  
// Check if running in development environment
if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_STAGING_AUTH0_DOMAIN;
  REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_DEVELOPMENT_AUTH0_CLIENT_ID;
  REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_DEVELOPMENT_AUTH0_AUDIENCE;
}

// Check if running in staging environment
if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
  REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_STAGING_AUTH0_DOMAIN;
  REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_STAGING_AUTH0_CLIENT_ID;
  REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_STAGING_AUTH0_AUDIENCE;
}

// Check if running in production environment
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_PRODUCTION_AUTH0_DOMAIN;
  REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_PRODUCTION_AUTH0_CLIENT_ID;
  REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_PRODUCTION_AUTH0_AUDIENCE;
}

// Check if running in preview environment
if (process.env.REACT_APP_ENVIRONMENT === 'preview') {
  REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_STAGING_AUTH0_DOMAIN;
  REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_STAGING_AUTH0_CLIENT_ID;
  REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_STAGING_AUTH0_AUDIENCE;
}

// Check if running in KBC environment
if (process.env.REACT_APP_ENVIRONMENT === 'KBC') {
  REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_KBC_AUTH0_DOMAIN;
  REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_KBC_AUTH0_CLIENT_ID;
  REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_KBC_AUTH0_AUDIENCE;
}

// Check if running in Vandelanotte environment
if (process.env.REACT_APP_ENVIRONMENT === 'vandelanotte') {
  REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_VANDELANOTTE_AUTH0_DOMAIN;
  REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_VANDELANOTTE_AUTH0_CLIENT_ID;
  REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_VANDELANOTTE_AUTH0_AUDIENCE;
}


  return (
    <Auth0Provider
      domain={REACT_APP_AUTH0_DOMAIN}
      clientId={REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: REACT_APP_AUTH0_AUDIENCE,
        }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
